import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/lib/Form";
import filesize from "filesize";
import { Formik, FieldArray } from "formik";
import moment from "moment";
import map from "lodash.map";
import filter from "lodash.filter";
import isEmpty from "lodash.isempty";
import orderBy from "lodash.orderby";
import isEqual from "lodash.isequal";
import findIndex from "lodash.findindex";
import Immutable from "seamless-immutable";
import { Button } from "../../Button";
import { ConsultationFormContainer } from "./ConsultationFormContainer";
import { CommentList } from "./CommentList";
import { ProjectCard } from "./ProjectCard";
import {
  ProjectStatus,
  ProjectType,
  ProjectMode,
  ConsultationFormType,
  ConsultationFormContainerType,
} from "../../../utils/enums";
import { Loader } from "../../Loader";
import { getActChild } from "../../../helpers/ActChildren";
import { Attachment } from "../../Attachment";

export class PreviewProjectCardForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: {
        act: true,
        survey: false,
        probe: false,
        contact: true,
        email:
          props.consultationForms && props.consultationForms.length > 0
            ? props.consultationForms.every(
                (item) => item.type === ConsultationFormType.EmailAddress
              )
            : false,
        postAddress: false,
      },
      agreementAccepted: props.agreementAccepted || false,
      hasOnlyPostAddressForm:
        props.consultationForms && props.consultationForms.length > 0
          ? props.consultationForms.every(
              (item) => item.type === ConsultationFormType.PostAddress
            )
          : false,
      ...this.calculateUserVote(),
    };
    this.projectCard = null;

    this.onChangeAgreementAccepted = (e) => {
      this.setState({
        agreementAccepted: e.target.checked,
      });
    };

    this.scrollToAgreement = this.scrollToAgreement.bind(this);

    this.toggleOpen = (e, name) => {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        opened: Immutable.merge(this.state.opened, {
          [name]: !this.state.opened[name],
        }),
      });
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.agreementAccepted !== this.props.agreementAccepted) {
      this.setState({
        agreementAccepted: this.props.agreementAccepted,
      });
    }
    if (!isEqual(prevProps.consultationForms, this.props.consultationForms)) {
      const newEmail =
        this.props.consultationForms && this.props.consultationForms.length > 0
          ? this.props.consultationForms.every(
              (item) => item.type === ConsultationFormType.EmailAddress
            )
          : false;
      this.setState({
        opened: Immutable.merge(this.state.opened, { email: newEmail }),
        hasOnlyPostAddressForm:
          this.props.consultationForms &&
          this.props.consultationForms.length > 0
            ? this.props.consultationForms.every(
                (item) => item.type === ConsultationFormType.PostAddress
              )
            : false,
        ...this.calculateUserVote(),
      });
    }
  }

  canSetProjectOpinion() {
    return false;
  }

  canCommentAndSetOpinion() {
    return false;
  }

  calculateUserVote() {
    if (
      isEmpty(
        filter(
          this.props.consultationForms,
          (form) =>
            form.type === ConsultationFormType.Probe ||
            form.type === ConsultationFormType.Survey
        )
      )
    ) {
      return {
        availableVoteForms: 0,
        voteForms: 0,
      };
    }

    return {
      availableVoteForms:
        filter(
          this.props.consultationForms,
          (form) =>
            form.type === ConsultationFormType.Probe ||
            form.type === ConsultationFormType.Survey
        ).length || 0,
      voteForms:
        filter(
          this.props.consultationForms,
          (form) =>
            (form.type === ConsultationFormType.Probe ||
              form.type === ConsultationFormType.Survey) &&
            form.voted
        ).length || 0,
    };
  }

  renderAttachmentsIcon(type) {
    switch (type) {
      case "application/pdf": {
        return (
          <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
      default: {
        return (
          <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
    }
  }

  renderAttachments(attachments) {
    return (
      <Fragment>
        <div className="consultations__title margin-top-25 margin-bottom-15">
          Załączniki
        </div>
        <div className="attachments-list">
          {map(attachments, (attachment) => (
            <Attachment
              key={attachment.id}
              {...{
                attachment,
                url: `/api/attachments/${attachment.id}`,
              }}
            >
              {this.renderAttachmentsIcon(attachment.contentType)}
            </Attachment>
          ))}
        </div>
      </Fragment>
    );
  }

  renderResultAttachments(resultAttachments) {
    return (
      <Fragment>
        <div className="consultations__title margin-top-25 margin-bottom-15">
          Opublikowane wyniki
        </div>
        <div className="attachments-list">
          {map(resultAttachments, (attachment) => (
            <Attachment
              key={attachment.id}
              {...{
                attachment,
                url: `/api/attachments/${attachment.id}`,
              }}
            >
              {this.renderAttachmentsIcon(attachment.contentType)}
            </Attachment>
          ))}
        </div>
      </Fragment>
    );
  }

  getContactForm = (email, postAddress) =>
    this.setState({
      opened: Immutable.merge(this.state.opened, {
        email: email,
        postAddress: postAddress,
      }),
    });

  renderAct() {
    const {
      act,
      showComment,
      addCommentOpinion,
      removeCommentOpinion,
      opinionExecuting,
      saveComment,
      consultationForms,
    } = this.props;
    const { childrens, attachments } = act;
    const childrenOrdered = orderBy(childrens, (c) => c.order);
    const projectId = this.props.id;
    const canCommentAndSetOpinion = this.canCommentAndSetOpinion();
    const userId = this.props.loggedUserId ? this.props.loggedUserId : 0;
    const showOpinion =
      findIndex(
        consultationForms,
        (cf) => cf.type === ConsultationFormType.Opinion
      ) !== -1;

    return (
      <div className="act">
        <div className="act__box">
          {map(
            filter(childrenOrdered, (c) => c.name !== "zalacznik"),
            (c) =>
              getActChild(c, {
                canCommentAndSetOpinion,
                addCommentOpinion,
                removeCommentOpinion,
                showComment,
                projectId,
                opinionExecuting,
                saveComment: (comment) => saveComment(comment),
                agreementAccepted: this.state.agreementAccepted,
                agreementAcceptedRequired: !isEmpty(
                  this.props.agreementHistory
                ),
                scrollToAgreement: this.scrollToAgreement,
                userId,
                showOpinion,
              })
          )}
        </div>
        {map(
          filter(childrenOrdered, (c) => c.name === "zalacznik"),
          (c) => (
            <div className="act__box">
              {getActChild(c, {
                canCommentAndSetOpinion,
                addCommentOpinion,
                removeCommentOpinion,
                projectId,
                showComment,
                opinionExecuting,
                saveComment: (comment) => saveComment(comment),
                agreementAccepted: this.state.agreementAccepted,
                agreementAcceptedRequired: !isEmpty(
                  this.props.agreementHistory
                ),
                scrollToAgreement: this.scrollToAgreement,
                userId,
                showOpinion,
              })}
            </div>
          )
        )}
        {attachments.length > 0 && (
          <Fragment>
            <div className="consultation__title margin-top-25 margin-bottom-15">
              Załączniki aktu
            </div>
            <div className="attachments-list">
              {map(attachments, (attachment) => (
                <Attachment
                  key={attachment.id}
                  {...{
                    attachment,
                    url: `/api/actAttachments/${attachment.id}`,
                  }}
                >
                  {this.renderAttachmentsIcon(attachment.contentType)}
                </Attachment>
              ))}
            </div>
          </Fragment>
        )}
      </div>
    );
  }
  scrollToAgreement() {
    this.projectCard.scrollToAgreement();
  }
  render() {
    let newComment = {
      id: 0,
      content: "",
      projectId: this.props.id,
      userId: this.props.loggedUserId ? this.props.loggedUserId : 0,
    };
    const {
      type,
      attachments,
      resultAttachments,
      isProjectLoading,
      isAuth,
      status,
      act,
      mode,
      modeName,
      loggedOfficeId,
      officeId,
      officeName,
      isOnlyOneOffice,
      resultSummary,
    } = this.props;
    // const onlyCommentForms =
    // 	!isEmpty(this.props.consultationForms) &&
    // 	this.props.consultationForms.every((form) => form.type === ConsultationFormType.Comment);
    const { opened, availableVoteForms, voteForms } = this.state;
    const probes = orderBy(
      filter(this.props.consultationForms, {
        type: ConsultationFormType.Probe,
      }),
      ["voteTo"]
    );
    const surveys = orderBy(
      filter(this.props.consultationForms, {
        type: ConsultationFormType.Survey,
      }),
      ["voteTo"]
    );
    const contacts = filter(
      this.props.consultationForms,
      (form) =>
        form.type === ConsultationFormType.PostAddress ||
        form.type === ConsultationFormType.EmailAddress
    );

    const showOpinion =
      findIndex(
        this.props.consultationForms,
        (cf) => cf.type === ConsultationFormType.Opinion
      ) !== -1;

    return (
      <Fragment>
        {isProjectLoading && <Loader loading={isProjectLoading} />}
        {!isProjectLoading && (
          <div id="content" className="container consultations">
            <ProjectCard
              ref={(ref) => (this.projectCard = ref)}
              {...this.props}
              canSetProjectOpinion={this.canSetProjectOpinion()}
              disabled={true}
              addProjectOpinion={(id, type) =>
                this.props.addProjectOpinion(id, type)
              }
              removeProjectOpinion={(id) => this.props.removeProjectOpinion(id)}
              opinionExecuting={this.props.opinionExecuting}
              onChangeAgreementAccepted={this.onChangeAgreementAccepted}
              availableVoteForms={availableVoteForms}
              voteForms={voteForms}
              agreementAccepted={this.props.agreementAccepted}
              actualAgreementAccepted={this.state.agreementAccepted}
              agreementAcceptedRequired={!isEmpty(this.props.agreementHistory)}
              scrollToAgreement={this.scrollToAgreement}
              getContactForm={this.getContactForm}
              openEmailForm={opened.email}
            />

            {!isEmpty(contacts) && type === ProjectType.Consultation && (
              <div className="consultations__item">
                <div className="consultations__body">
                  <div className="consultations__item">
                    {opened.email && (
                      <div className="comments-list">
                        <FieldArray
                          id="consultationForms"
                          name="consultationForms"
                          render={(arrayHelpers) => (
                            <ConsultationFormContainer
                              consultationFormContainerType={
                                ConsultationFormContainerType.Contact
                              }
                              disabled={true}
                              loggedUserId={this.props.loggedUserId}
                              loggedUserIsCitizen={
                                this.props.loggedUserIsCitizen
                              }
                              projectType={this.props.type}
                              items={contacts}
                              agreementAccepted={this.state.agreementAccepted}
                              agreementHistory={this.props.agreementHistory}
                              agreementAcceptedRequired={
                                !isEmpty(this.props.agreementHistory)
                              }
                              scrollToAgreement={this.scrollToAgreement}
                              saveAnswers={this.props.saveAnswers}
                              voteExecuting={this.props.voteExecuting}
                              isLegalAgeUser={this.props.isLegalAgeUser}
                              onlyForLegalAge={this.props.onlyForLegalAge}
                              onCancel={(e) => this.toggleOpen(e, "email")}
                              isOnlyOneConsultationForms={
                                this.props.consultationForms.length > 0 &&
                                this.props.consultationForms.length === 1
                              }
                              isAuth={isAuth}
                              projectStatus={status}
                              mode={mode}
                              modeName={modeName}
                              loggedOfficeId={loggedOfficeId}
                              officeId={officeId}
                              officeName={officeName}
                              isOnlyOneOffice={isOnlyOneOffice}
                              resultSummary={resultSummary}
                              title={this.props.title}
                              thematicAreaId={this.props.thematicAreaId}
                              districtId={this.props.districtId}
                              projectId={this.props.id}
                              openEmailForm={opened.email}
                              onSetExpandStateItem={
                                this.props.onSetExpandStateItem
                              }
                              expand={this.props.expand}
                            />
                          )}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {!isEmpty(this.props.consultationForms) && (
              <div
                className={`consultation__fields${
                  this.props.type === ProjectType.PublicBudget
                    ? " consultation__fields--no-top-padding"
                    : ""
                }`}
              >
                {!isEmpty(act) &&
                  !isEmpty(act.childrens) &&
                  type === ProjectType.Consultation && (
                    <div className="consultations__item">
                      <div className="consultations__body">
                        <div className="consultations__item consultations__item--no-margins consultations__item--no-padding">
                          <div
                            className="consultations__header"
                            onClick={(e) => this.toggleOpen(e, "act")}
                          >
                            <div className="consultations__title consultations__title--center">
                              Akt prawny
                            </div>
                            <div className="consultations__icons">
                              <div
                                className="consultations__switch consultations__switch--primary-dark"
                                onClick={(e) => this.toggleOpen(e, "act")}
                              >
                                {opened.act ? "Zwiń" : "Rozwiń"}
                                {
                                  <i
                                    className={`consultations__icon fas fa-angle-${
                                      opened.act ? "up" : "down"
                                    }`}
                                  />
                                }
                              </div>
                            </div>
                          </div>
                          {opened.act && (
                            <div className="consultations__body">
                              <div className="consultations__item">
                                {this.renderAct()}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                {!isEmpty(surveys) && type === ProjectType.Consultation && (
                  <div className="consultations__item">
                    <div className="consultations__body">
                      <div className="consultations__item consultations__item--no-margins consultations__item--no-padding">
                        <div className="consultations__header">
                          <div
                            className="consultations__title consultations__title--center"
                            onClick={(e) => this.toggleOpen(e, "survey")}
                          >
                            Ankiety
                          </div>
                          <div className="consultations__icons">
                            <div
                              className="consultations__switch consultations__switch--primary-dark"
                              onClick={(e) => this.toggleOpen(e, "survey")}
                            >
                              {opened.survey ? "Zwiń" : "Rozwiń"}
                              {
                                <i
                                  className={`consultations__icon fas fa-angle-${
                                    opened.survey ? "up" : "down"
                                  }`}
                                />
                              }
                            </div>
                          </div>
                        </div>
                        {opened.survey && (
                          <div className="consultations__body">
                            <div className="consultations__item">
                              <FieldArray
                                id="consultationForms"
                                name="consultationForms"
                                render={(arrayHelpers) => (
                                  <ConsultationFormContainer
                                    disabled={true}
                                    loggedUserId={this.props.loggedUserId}
                                    loggedUserIsCitizen={
                                      this.props.loggedUserIsCitizen
                                    }
                                    projectType={this.props.type}
                                    items={surveys}
                                    agreementAccepted={
                                      this.state.agreementAccepted
                                    }
                                    agreementHistory={
                                      this.props.agreementHistory
                                    }
                                    agreementAcceptedRequired={
                                      !isEmpty(this.props.agreementHistory)
                                    }
                                    saveAnswers={this.props.saveAnswers}
                                    voteExecuting={this.props.voteExecuting}
                                    isLegalAgeUser={this.props.isLegalAgeUser}
                                    onlyForLegalAge={this.props.onlyForLegalAge}
                                    onCancel={this.props.onCancel}
                                    scrollToAgreement={this.scrollToAgreement}
                                    isOnlyOneConsultationForms={
                                      this.props.consultationForms.length > 0 &&
                                      this.props.consultationForms.length === 1
                                    }
                                    isAuth={isAuth}
                                    projectStatus={status}
                                    mode={mode}
                                    modeName={modeName}
                                    loggedOfficeId={loggedOfficeId}
                                    officeId={officeId}
                                    officeName={officeName}
                                    isOnlyOneOffice={isOnlyOneOffice}
                                    resultSummary={resultSummary}
                                    isPreview={this.props.isPreview}
                                    onSetExpandStateItem={
                                      this.props.onSetExpandStateItem
                                    }
                                    expand={this.props.expand}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {!isEmpty(probes) && type === ProjectType.Consultation && (
                  <div className="consultations__item">
                    <div className="consultations__body">
                      <div className="consultations__item consultations__item--no-margins consultations__item--no-padding">
                        <div
                          className="consultations__header"
                          onClick={(e) => this.toggleOpen(e, "probe")}
                        >
                          <div className="consultations__title consultations__title--center">
                            Sondy
                          </div>
                          <div className="consultations__icons">
                            <div
                              className="consultations__switch consultations__switch--primary-dark"
                              onClick={(e) => this.toggleOpen(e, "probe")}
                            >
                              {opened.probe ? "Zwiń" : "Rozwiń"}
                              {
                                <i
                                  className={`consultations__icon fas fa-angle-${
                                    opened.probe ? "up" : "down"
                                  }`}
                                />
                              }
                            </div>
                          </div>
                        </div>
                        {opened.probe && (
                          <div className="consultations__body">
                            <div className="consultations__item">
                              <FieldArray
                                id="consultationForms"
                                name="consultationForms"
                                render={(arrayHelpers) => (
                                  <ConsultationFormContainer
                                    disabled={true}
                                    loggedUserId={this.props.loggedUserId}
                                    loggedUserIsCitizen={
                                      this.props.loggedUserIsCitizen
                                    }
                                    projectType={this.props.type}
                                    items={probes}
                                    agreementAccepted={
                                      this.state.agreementAccepted
                                    }
                                    agreementHistory={
                                      this.props.agreementHistory
                                    }
                                    agreementAcceptedRequired={
                                      !isEmpty(this.props.agreementHistory)
                                    }
                                    saveAnswers={this.props.saveAnswers}
                                    voteExecuting={this.props.voteExecuting}
                                    isLegalAgeUser={this.props.isLegalAgeUser}
                                    onlyForLegalAge={this.props.onlyForLegalAge}
                                    onCancel={this.props.onCancel}
                                    scrollToAgreement={this.scrollToAgreement}
                                    isOnlyOneConsultationForms={
                                      this.props.consultationForms.length > 0 &&
                                      this.props.consultationForms.length === 1
                                    }
                                    isAuth={isAuth}
                                    projectStatus={status}
                                    mode={mode}
                                    modeName={modeName}
                                    loggedOfficeId={loggedOfficeId}
                                    officeId={officeId}
                                    officeName={officeName}
                                    isOnlyOneOffice={isOnlyOneOffice}
                                    resultSummary={resultSummary}
                                    isPreview={this.props.isPreview}
                                    onSetExpandStateItem={
                                      this.props.onSetExpandStateItem
                                    }
                                    expand={this.props.expand}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {type !== ProjectType.Consultation && (
                  <FieldArray
                    id="consultationForms"
                    name="consultationForms"
                    render={(arrayHelpers) => (
                      <ConsultationFormContainer
                        disabled={true}
                        loggedUserId={this.props.loggedUserId}
                        loggedUserIsCitizen={this.props.loggedUserIsCitizen}
                        projectType={this.props.type}
                        items={this.props.consultationForms}
                        agreementAccepted={this.state.agreementAccepted}
                        agreementHistory={this.props.agreementHistory}
                        agreementAcceptedRequired={
                          !isEmpty(this.props.agreementHistory)
                        }
                        saveAnswers={this.props.saveAnswers}
                        voteExecuting={this.props.voteExecuting}
                        isLegalAgeUser={this.props.isLegalAgeUser}
                        onlyForLegalAge={this.props.onlyForLegalAge}
                        onCancel={this.props.onCancel}
                        scrollToAgreement={this.scrollToAgreement}
                        isOnlyOneConsultationForms={
                          this.props.consultationForms.length > 0 &&
                          this.props.consultationForms.length === 1
                        }
                        isAuth={isAuth}
                        projectStatus={status}
                        mode={mode}
                        isPreview={this.props.isPreview}
                      />
                    )}
                  />
                )}
              </div>
            )}
            {attachments &&
              attachments.length > 0 &&
              type === ProjectType.Consultation && (
                <div className="consultations__item">
                  <div className="consultations__body">
                    <div className="consultations__item">
                      {this.renderAttachments(attachments)}
                    </div>
                  </div>
                </div>
              )}
            {attachments &&
              attachments.length > 0 &&
              type !== ProjectType.Consultation &&
              this.renderAttachments(attachments)}

            {resultAttachments &&
              resultAttachments.length > 0 &&
              type === ProjectType.Consultation && (
                <div className="consultations__item">
                  <div className="consultations__body">
                    <div className="consultations__item">
                      {this.renderResultAttachments(resultAttachments)}
                    </div>
                  </div>
                </div>
              )}
            {resultAttachments &&
              resultAttachments.length > 0 &&
              type !== ProjectType.Consultation &&
              this.renderResultAttachments(resultAttachments)}

            {this.props.showComment && (
              <div className="consultations__item">
                <div className="consultations__body">
                  <div className="consultations__item">
                    <div className="comments-list">
                      <div className="consultation__title margin-top-30 margin-bottom-15">
                        Komentarze ({this.props.commentCount})
                      </div>
                      {this.canCommentAndSetOpinion() && (
                        <Formik
                          enableReinitialize={true}
                          initialValues={newComment}
                          validateOnChange={false}
                          render={({
                            values,
                            handleChange,
                            isValid,
                            setValues,
                          }) => (
                            <Form noValidate method="post">
                              <textarea
                                id={`comment-content`}
                                name={`content`}
                                className="act__comments-textarea"
                                value={values.content}
                                onChange={handleChange}
                                aria-label="Treść komentarza"
                              />
                              <div className="act__comments-btn-cont">
                                <button
                                  className="act__comments-btn"
                                  disabled={true}
                                >
                                  Dodaj
                                </button>
                              </div>
                            </Form>
                          )}
                        />
                      )}
                      <CommentList
                        canCommentAndSetOpinion={this.canCommentAndSetOpinion()}
                        disabled={true}
                        loggedUserId={this.props.loggedUserId}
                        projectType={this.props.type}
                        items={this.props.comments}
                        addCommentOpinion={(id, type) =>
                          this.props.addCommentOpinion(id, type)
                        }
                        removeCommentOpinion={(id) =>
                          this.props.removeCommentOpinion(id)
                        }
                        opinionExecuting={this.props.opinionExecuting}
                        agreementAccepted={this.state.agreementAccepted}
                        agreementAcceptedRequired={
                          !isEmpty(this.props.agreementHistory)
                        }
                        scrollToAgreement={this.scrollToAgreement}
                        showOpinion={showOpinion}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </Fragment>
    );
  }
}

PreviewProjectCardForm.propTypes = {
  commentCount: PropTypes.number,
  consultationTitle: PropTypes.string,
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  loggedUserId: PropTypes.number,
  id: PropTypes.number,
  isAuth: PropTypes.bool,
  modeName: PropTypes.string,
  moderatorName: PropTypes.string,
  shortDescription: PropTypes.string,
  statusName: PropTypes.string,
  thematicAreaName: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.number,

  addCommentOpinion: PropTypes.func,
  addProjectOpinion: PropTypes.func,
  onCancel: PropTypes.func,
  removeCommentOpinion: PropTypes.func,
  removeProjectOpinion: PropTypes.func,
  saveAnswers: PropTypes.func,
  saveComment: PropTypes.func,
};

PreviewProjectCardForm.defaultProps = {
  commentCount: 0,
  consultationTitle: "",
  dateFrom: moment().format("YYYY-MM-DD"),
  dateTo: moment().format("YYYY-MM-DD"),
  description: "",
  disabled: false,
  loggedUserId: 0,
  id: 0,
  isAuth: false,
  modeName: "",
  moderatorName: "",
  shortDescription: "",
  statusName: "",
  thematicAreaName: "",
  title: "",
  type: 0,
  agreementHistory: null,
  agreementAccepted: false,
  opinionExecuting: [],
  voteExecuting: [],

  addCommentOpinion: Function.prototype,
  addProjectOpinion: Function.prototype,
  onCancel: Function.prototype,
  removeCommentOpinion: Function.prototype,
  removeProjectOpinion: Function.prototype,
  saveAnswers: Function.prototype,
  saveComment: Function.prototype,
};
